import React, { useState, useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import ModalModule from '../modal';
import UI from '../ui';
import Utils from '../utils';
import TermsContent from './TermsContent.component';

const { ModalContext } = ModalModule;
const { WrappedButton } = UI;
const { Communication, Session, Util } = Utils;

export const TermsPage = ({ callback }) => {
	const [termContent, setTermContent] = useState(null);
	const [termVersion, setTermVersion] = useState(0);
	const [isLoading, setIsLoading] = useState(true);
	const [acceptSuccessful, setAcceptSuccessful] = useState(false);
	const { showError } = useContext(ModalContext);
	const { termType } = useParams();

	const { isSignedIn } = Session.getData();
	const showAccept = isSignedIn && Util.isInRoute('showAccept');

	const getTerms = async () => {
		const response = await Communication.getTerms(termType);

		if (!Communication.isSuccessful(response)) {
			return showError({ response });
		}

		setIsLoading(false);
		setTermContent(response.data.Content);
		setTermVersion(response.data.TermsVersion);
	};

	useEffect(() => {
		getTerms();
	}, []);

	const onAccept = async () => {
		const currentDate = Util.getCurrentDate();
		const params = {
			TermType: termType,
			ViewedDate: currentDate,
			AcceptedDate: currentDate,
			ViewedVersion: termVersion,
			AcceptedVersion: termVersion,
			IntegrationId: Util.getQueryParamByName('iid') || null,
		};

		setIsLoading(true);

		const response = await Communication.acceptTerms(params);

		if (!Communication.isSuccessful(response)) {
			setIsLoading(false);

			return showError({ response });
		} else {
			setAcceptSuccessful(true);
		}

		// notify caller that the terms have been accepted
		if (callback) {
			callback(true);
		}
	};

	return (
		<div className="common-terms terms-page">
			<TermsContent termsContent={termContent} />
			{showAccept && (
				<div className="action-row">
					<WrappedButton
						className="accept-button"
						label="Accept"
						disabled={isLoading}
						onClick={onAccept}
						dataqa="terms-page-accept"
					/>
					{acceptSuccessful && <p className="success-text">Terms Accepted.</p>}
				</div>
			)}
		</div>
	);
};
